import { Booth } from "src/components/Booth";

export default {
    background: "https://assets.swoogo.com/uploads/full/3027223-65242cdf6a2ef.png",
    links: [
        {
            label: "Previous Room",
            href: "/exhibition-hall-platinum",
            width: "16%",
            height: "7%",
            left: "24.3%",
            top: "90%",
        },
        {
            label: "Back To Main Hall",
            href: "/exhibition-hall",
            width: "17.4%",
            height: "7%",
            left: "41.3%",
            top: "90%",
        },
        {
            label: "Next Room",
            href: "/exhibition-hall-silver-bronze",
            width: "16.4%",
            height: "7%",
            left: "59.3%",
            top: "90%",
        },
    ],
    extras: <>
        <Booth position={{
            width: "36.3%",
            left: "6.8%",
            top: "6.6%",
        }} boothId="4ee8d857-4c8e-4edd-822b-7c6f403b0045" />
        <Booth position={{
            width: "36.3%",
            left: "56.8%",
            top: "6.6%",
        }} boothId="84bbf12f-fa5d-4bf9-b728-f9fcafa2f6d4" />
        <Booth position={{
            width: "36.1%",
            left: "6.8%",
            top: "45.6%",
        }} boothId="55c20fce-01ca-4ad1-a605-0fe2ed3b0edf" />
        <Booth position={{
            width: "36.1%",
            left: "56.8%",
            top: "45.6%",
        }} boothId="2bcf2be4-0056-455a-8b5f-0f4b96226c91" />
    </>,
    name: "exhibition-hall-gold",
}